var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7677 6.94605C14.6498 6.75784 11.7304 2.67188 8 2.67188C4.26964 2.67188 1.35022 6.75776 1.23227 6.92723C0.922578 7.37916 0.922578 8.0381 1.23227 8.47127C1.35024 8.67826 4.26964 12.7643 8 12.7643C11.7304 12.7643 14.6498 8.67839 14.7677 8.50893C15.0774 8.057 15.0774 7.37926 14.7677 6.94612V6.94605ZM8 11.2767C6.46662 11.2767 5.21329 9.69512 5.21329 7.73687C5.21329 5.77872 6.46662 4.17819 8 4.17819C9.53338 4.17819 10.7867 5.77872 10.7867 7.73687C10.7867 9.67626 9.53338 11.2767 8 11.2767Z",
    fill: "#1A1A1A",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99943 5.62891C7.10002 5.62891 6.36279 6.57036 6.36279 7.71892C6.36279 8.86749 7.10002 9.80894 7.99943 9.80894C8.89885 9.80894 9.63608 8.86749 9.63608 7.71892C9.63608 6.57036 8.89885 5.62891 7.99943 5.62891Z",
    fill: "#1A1A1A",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9b0821cf7116fc72c975a7460820c3c5.svg";
export { ForwardRef as ReactComponent };